/* Minomake cart page: quantity changes, removal and gift box add-on without full reloads.
   Regions marked data-region are re-rendered by Shopify (Section Rendering API), so money is always formatted server-side.
   Quantity changes are debounced and sent together with /cart/update.js. */
(function(){
  var REGIONS = ['msg', 'lines', 'upsell', 'summary', 'cta'];
  var pending = {};      // line key -> wanted quantity, not sent yet
  var timer = null, busy = false, reloading = false;

  function form(){ return document.getElementById('mm-cart-form'); }
  function q(s, r){ return (r || document).querySelector(s); }
  function sectionId(){ var f = form(); return f && f.getAttribute('data-section'); }
  function fallbackError(){ var f = form(); return (f && f.getAttribute('data-error')) || ''; }

  function post(url, body){
    return fetch(url, {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify(body)
    }).then(function(r){
      return r.json().catch(function(){ return {}; }).then(function(j){
        if (!r.ok) { var e = new Error(j.description || j.message || ''); e.fromShopify = !!(j.description || j.message); throw e; }
        return j;
      });
    });
  }

  // Which control had focus, described so it can be found again after the regions are replaced
  function focusInfo(){
    var el = document.activeElement;
    if (!el || !el.closest) return null;
    var region = el.closest('[data-region]');
    if (!region) return null;
    var line = el.closest('.cart-line');
    var kind = el.getAttribute('data-qty-step') ? 'step:' + el.getAttribute('data-qty-step')
      : el.name === 'updates[]' ? 'input'
      : el.hasAttribute('data-remove') ? 'remove'
      : el.name === 'checkout' ? 'checkout'
      : el.hasAttribute('data-add-gift') ? 'gift' : null;
    return kind ? {key: line && line.getAttribute('data-key'), kind: kind} : null;
  }
  function restoreFocus(info){
    if (!info) return;
    var scope = info.key ? q('.cart-line[data-key="' + info.key + '"]') : document;
    if (!scope) return;
    var sel = info.kind.indexOf('step:') === 0 ? '[data-qty-step="' + info.kind.slice(5) + '"]'
      : info.kind === 'input' ? 'input[name="updates[]"]'
      : info.kind === 'remove' ? '[data-remove]'
      : info.kind === 'checkout' ? '[name="checkout"]' : '[data-add-gift]';
    var el = scope.querySelector(sel);
    if (el) el.focus();
  }

  function swap(html){
    var info = focusInfo();
    var doc = new DOMParser().parseFromString(html, 'text/html');
    REGIONS.forEach(function(name){
      var a = q('[data-region="' + name + '"]'), b = doc.querySelector('[data-region="' + name + '"]');
      if (a && b) a.innerHTML = b.innerHTML;
    });
    var express = q('.cart-express');
    if (express) express.hidden = !q('[data-region="cta"] [name="checkout"]');
    restoreFocus(info);
  }

  function setCount(n){ var c = document.getElementById('cart-count'); if (c) c.textContent = n; }
  function setBusy(on){ var f = form(); if (!f) return; f.classList.toggle('is-busy', on); f.setAttribute('aria-busy', on ? 'true' : 'false'); }
  function showError(msg){ var e = document.getElementById('cart-error'); if (!e) return; e.textContent = msg || ''; e.hidden = !msg; }
  function announce(){
    var l = document.getElementById('cart-live'), dt = q('.cs-total dt'), dd = q('.cs-total dd');
    if (!l || !dd) return;
    l.textContent = '';
    setTimeout(function(){ l.textContent = (dt ? dt.textContent + ' ' : '') + dd.textContent; }, 60);
  }
  function reload(){ reloading = true; clearTimeout(timer); location.reload(); }

  // Re-render the regions from the current cart (after an error, so quantities show the truth). Never rejects.
  function refresh(){
    var sid = sectionId(); if (!sid) return Promise.resolve();
    return fetch(location.pathname + '?section_id=' + encodeURIComponent(sid), {headers: {'Accept': 'text/html'}})
      .then(function(r){ return r.ok ? r.text() : null; })
      .then(function(html){ if (html) swap(html); })
      .catch(function(){});
  }

  // Send every pending quantity in one request. Resolves when done (also after errors).
  function sync(){
    clearTimeout(timer); timer = null;
    if (reloading) return Promise.resolve();
    if (busy) return new Promise(function(res){ setTimeout(function(){ sync().then(res); }, 120); });
    var updates = pending; pending = {};
    var keys = Object.keys(updates);
    if (!keys.length) return Promise.resolve();
    busy = true; setBusy(true); showError('');
    var removing = keys.some(function(k){ return updates[k] === 0; });
    var sid = sectionId();
    function done(){ busy = false; setBusy(false); if (Object.keys(pending).length && !reloading) schedule(); }
    return post(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/update.js' : '/cart/update.js', {updates: updates, sections: [sid]})
      .then(function(cart){
        if (removing || cart.item_count === 0) { reload(); return; }
        setCount(cart.item_count);
        var html = cart.sections && cart.sections[sid];
        if (html) swap(html); else return refresh();
        keys.forEach(function(k){
          var input = q('.cart-line[data-key="' + k + '"] input[name="updates[]"]');
          if (input && +input.value !== updates[k]) showError(fallbackError());
        });
        announce();
      })
      .catch(function(err){
        showError(err && err.fromShopify ? err.message : fallbackError());
        return refresh();
      })
      .then(done, done);
  }

  function schedule(){ clearTimeout(timer); timer = setTimeout(sync, 350); }

  function setQty(input, wanted){
    var max = parseInt(input.getAttribute('max'), 10) || 10;
    var current = parseInt(input.getAttribute('data-qty'), 10) || 0;
    var v = Math.max(0, parseInt(wanted, 10) || 0);
    v = Math.min(v, Math.max(max, current)); // never lowers a quantity that is already above the max
    input.value = v;
    pending[input.getAttribute('data-key')] = v;
    schedule();
  }

  document.addEventListener('click', function(e){
    var t = e.target; if (!t.closest || !form() || reloading) return;
    var step = t.closest('[data-qty-step]');
    if (step && step.closest('#mm-cart-form')) {
      var input = step.parentNode.querySelector('input[name="updates[]"]');
      if (input) setQty(input, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-qty-step'), 10));
      return;
    }
    var rm = t.closest('[data-remove]');
    if (rm && rm.closest('#mm-cart-form')) {
      e.preventDefault();
      pending[rm.getAttribute('data-remove')] = 0;
      sync();
      return;
    }
    var up = t.closest('[data-upgrade]');
    if (up && up.closest('#mm-cart-form')) {
      e.preventDefault();
      sync().then(function(){
        if (reloading) return;
        busy = true; setBusy(true); showError('');
        // The new set goes in first: if that fails the 1-kit line is still there
        var kit = {id: parseInt(up.getAttribute('data-variant'), 10), quantity: 1};
        // Liquid prints line properties as [[name, value], ...]
        var props = {};
        var lineProps = JSON.parse(up.getAttribute('data-props') || '[]');
        if (Array.isArray(lineProps)) lineProps.forEach(function(p){ props[p[0]] = p[1]; });
        if (Object.keys(props).length) kit.properties = props;
        var items = [kit];
        if (up.getAttribute('data-gift')) items.push({id: parseInt(up.getAttribute('data-gift'), 10), quantity: 1});
        var removal = {}; removal[up.getAttribute('data-upgrade')] = 0;
        return post(form().getAttribute('data-add-url') + '.js', {items: items})
          .then(function(){ return post(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/update.js' : '/cart/update.js', {updates: removal}); })
          .then(reload)
          .catch(function(err){
            busy = false; setBusy(false); showError(err && err.fromShopify ? err.message : fallbackError());
            return refresh();
          });
      });
      return;
    }
    var gift = t.closest('[data-add-gift]');
    if (gift && gift.closest('#mm-cart-form')) {
      e.preventDefault();
      var id = parseInt(gift.getAttribute('data-add-gift'), 10);
      sync().then(function(){
        if (reloading) return;
        busy = true; setBusy(true); showError('');
        return post(form().getAttribute('data-add-url') + '.js', {items: [{id: id, quantity: 1}]})
          .then(reload)
          .catch(function(err){ busy = false; setBusy(false); showError(err && err.fromShopify ? err.message : fallbackError()); });
      });
    }
  });

  document.addEventListener('change', function(e){
    var t = e.target;
    if (t.name === 'updates[]' && t.closest && t.closest('#mm-cart-form') && !reloading) setQty(t, t.value);
  });

  document.addEventListener('keydown', function(e){
    var t = e.target;
    if (e.key === 'Enter' && t.name === 'updates[]' && t.closest && t.closest('#mm-cart-form')) { e.preventDefault(); setQty(t, t.value); sync(); }
  });

  // Coming back from checkout with the browser's back button: show the real cart
  window.addEventListener('pageshow', function(e){ if (e.persisted && document.body.classList.contains('tpl-cart')) location.reload(); });
})();
